








import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import BrokerLogs from '@/components/BrokerLogs.vue';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';

@Component({
  components: {
    BrokerLogs,
  },
})
export default class BrokerLogsTab extends Vue {
  @Prop()
  pmodule!: PModuleWithMeasurements;

  // Список выбранных идентификаторов программных модулей
  selectedPModuleIds: string[] = [];

  async created() {
    if (this.pmodule.guid) this.selectedPModuleIds = [this.pmodule.guid];
  }

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(this.pmodule.type) as any) as PModuleStoreModule;
  }
}
